module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.1ceab5cd.jpg";